var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "520px",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "130px",
            size: "small",
          },
        },
        [
          _c("el-form-item", { attrs: { label: "对账单号：" } }, [
            _c("span", { staticClass: "readonly-value" }, [
              _vm._v(_vm._s(_vm.form.statementNo || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "商家名称：" } }, [
            _c("span", { staticClass: "readonly-value" }, [
              _vm._v(_vm._s(_vm.form.merchantName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "打款公司主体：", prop: "companyId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择打款公司主体",
                    filterable: "",
                    loading: _vm.companyLoading,
                  },
                  model: {
                    value: _vm.form.companyId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "companyId", $$v)
                    },
                    expression: "form.companyId",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.companyName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商家订单数据：" } },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadRef",
                  staticClass: "upload-demo",
                  attrs: {
                    action: "#",
                    "http-request": _vm.handleFileUpload,
                    "on-remove": _vm.handleUploadRemove,
                    "file-list": _vm.fileList,
                    multiple: "",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.uploadLoading,
                      },
                    },
                    [_vm._v("选择文件")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("支持所有文件格式")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对账备注：", "label-width": _vm.labelWidth } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入对账备注",
                  maxlength: "500",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.reconciliationRemark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reconciliationRemark", $$v)
                  },
                  expression: "form.reconciliationRemark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }